import { useState, useEffect } from "react";
import "./App.css";
import axios from "axios";
import Login from "./components/Login";
import Home from "./components/Home";
import logo from "./assets/logoMain.png";
import host from "./components/host";
import GscLogin from "./components/GscLogin";
import GscHome from "./components/GscHome";

function App() {
  const [loggedIn, setLoggedIn] = useState(0);
  const [idNumInput, setIdNumInput] = useState(0);
  const [passInput, setPassInput] = useState("");
  const [studentId, setStudentId] = useState(0);
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    const sessionId = sessionStorage.getItem("studentId");

    if (sessionId !== null) {
      setLoggedIn(true);
      setStudentId(sessionId);
    }
  }, []);

  const idNumInputChange = (e) => {
    setIdNumInput(e.target.value);
  };

  const passInputChange = (e) => {
    setPassInput(e.target.value);
  };

  const loginGsc = () => {
    setLoggedIn(2);
  };

  const gscAuth = (pass) => {
    if (pass === "pe@c1@dm1n") {
      setLoggedIn(3);
    } else {
      alert("Wrong Password");
    }
  };

  const akanAuthCheck = (e) => {
    axios
      .post(
        `${host}checkAkan`,
        {
          studentIdInput: idNumInput,
          passInput: passInput,
        },
        {
          timeout: 10000, // 10 seconds
        },
      )
      .then((res) => {
        console.log(res.data);
        switch (parseInt(res.data)) {
          case 0:
            alert(
              "You have either entered a wrong ID Number or you haven't paid the AKAN Fee yet",
            );
            break;
          case 1:
            sessionStorage.setItem("studentId", idNumInput);
            setLoggedIn(true);
            setStudentId(idNumInput);
            break;
          case 2:
            alert("ID Number and password did not match");
            break;
          case 3:
            alert("Account Expired! Please renew your account.");
            break;
          default:
            alert("Unknown Error, Please contact the developer");
            break;
        }
        setLoginLoading(false);
      })
      .catch((error) => {
        alert("Server is Busy or Offline. Please try again later.");
        setLoginLoading(false);
      });
    /* axios
      .post(`${host}checkAkan`, {
        studentIdInput: idNumInput,
        passInput: passInput,
      })
      .then((res) => {
        switch (res.data) {
          case 0:
            alert(
              "You have either entered a wrong ID Number or you haven't paid the AKAN Fee yet"
            );
            break;
          case 1:
            alert("You have successfully logged in!");
            sessionStorage.setItem("studentId", idNumInput);
            setLoggedIn(true);
            setStudentId(idNumInput);
            break;
          case 2:
            alert("ID Number and password did not match");
            break;
          case 3:
            alert("Account Expired! Please renew your account.");
            break;
          default:
            alert("Unknown Error, Please contact the developer");
            break;
        }
        setLoginLoading(false);
      }); */
  };

  const login = (e) => {
    setLoginLoading(true);
    e.preventDefault();
    if (loggedIn) {
      setLoggedIn(0);
      setPassInput("");
      sessionStorage.clear();
      setLoginLoading(false);
    } else {
      akanAuthCheck();
    }
  };

  const loggedCheck = () => {
    switch (loggedIn) {
      case 0:
        return (
          <Login
            onLog={login}
            logo={logo}
            idNumInput={idNumInputChange}
            passInput={passInputChange}
            loginLoading={loginLoading}
            loginGsc={loginGsc}
          />
        );
      case 1:
        return <Home onLog={login} studentId={studentId} />;
      case 2:
        return <GscLogin gscAuth={gscAuth} />;
      case 3:
        return <GscHome />;
      default:
        return <Home onLog={login} studentId={studentId} />;
    }
  };

  return <div className="App">{loggedCheck()}</div>;
}

export default App;
